import { render, staticRenderFns } from "./PricesInTable.html?vue&type=template&id=0ec83e5c&scoped=true&"
import script from "./PricesInTable.js?vue&type=script&lang=js&"
export * from "./PricesInTable.js?vue&type=script&lang=js&"
import style0 from "./PricesInTable.scss?vue&type=style&index=0&id=0ec83e5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec83e5c",
  null
  
)

export default component.exports